import { UploadFile } from "Components/Common/UploadFile/UploadFile";

export const ViewForm = ({ providerFormDetail }) => {
  return providerFormDetail?.map((file, index) => (
    <div className="p-2" key={index}>
      <UploadFile label={file.label} value={file.value} />
    </div>
  ));
};
